<ng-container [ngSwitch]="displayType$">

    <ng-container *ngSwitchDefault>
        <h1>Loading..</h1>
    </ng-container>

    <!-- Progress
        class="mat-elevation-z5"
        style="text-align: center; background-color: white; padding: 25px; border-radius: 5px; margin: 20px;"
        -->
    <div *ngSwitchCase="displayTypes$.Progress">
        <mat-spinner
                style="margin: 0 auto;"
                [color]="getSingleColor(displayConfig.color || 'primary')"
                [diameter]="dialogValues.size"
                [mode]="displayConfig.mode ? displayConfig.mode : 'indeterminate'"
                [value]="displayConfig.progress || 0"
        ></mat-spinner>
        <p
            style="text-align: center; margin-top: 20px; white-space: pre-line;"
            *ngIf="displayConfig.progressTitle">
            {{ displayConfig.progressTitle }}
        </p>
    </div>

    <!-- Spinner -->
    <div *ngSwitchCase="displayTypes$.MatSpinner"
         style="margin: 5px; text-align: center; overflow-x: hidden; overflow-y: hidden; overflow: hidden;">
        <mat-spinner

                [color]="getSingleColor(displayConfig.color || 'primary')"
                [diameter]="dialogValues.size"
                mode="indeterminate"></mat-spinner>
    </div>

    <!-- Spinner -->
    <rs-loading-modal-spinkit
            *ngSwitchCase="displayTypes$.SpinKit"
            [type]="dialogValues.spinkit"
            [size]="dialogValues.size"
            [color]="dialogValues.color"
    >
        </rs-loading-modal-spinkit>

    <!-- MatIcon -->
    <mat-icon
            style="margin: 5px;"
            [style.height]="dialogValues.size + 'px'"
            [style.width]="dialogValues.size + 'px'"
            [style.font-size]="dialogValues.size + 'px'"
            [color]="getSingleColor(dialogValues.color)"
            *ngSwitchCase="displayTypes$.MatIcon"
            class="rs-spin"
            [ngClass]="{'rs-spin': dialogValues.iconAnimation === iconAnimationTypes$.Spin, 'rs-shake': dialogValues.iconAnimation === iconAnimationTypes$.Shake}"
        >{{dialogValues.icon}}</mat-icon>

</ng-container>

